import Swiper, { Autoplay, Pagination } from "swiper";
// import "swiper/css";

(() => {
  window.addEventListener("DOMContentLoaded", () => {
    const heroSwiper = new Swiper(".js-heroSwiper", {
      modules: [Autoplay, Pagination],
      speed: 500,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
    });
  });
})();
